module.exports = __webpack_public_path__ + "img/bottom-img.ce1bec3e.svg";